
import 'react-circular-progressbar/dist/styles.css';
function ServicesComponent({...props }) {
  const percentage = 50;

  return (
    <div className="witemBody">
    <div className="row g-0 justify-content-center">

        <div className="col-lg-9">
            <div className="top-h4 d-lg-block d-none">
                <h4 className="shape-round">خدمات تهمك</h4>
            </div>
            <div className="wrapper-witeBody">
                
                <div className="row g-0 justify-content-center">
                    <div className="col-2">
                        <div className="imgText">
                            <a href="https://sahel.tatweertransit.com">
                                <img src="/static/img/05.png" alt="img" className="img-fluid img05" />
                                <h4 className="shape-round">حجز قاعة اجتماعات</h4>
                            </a>
                        </div>
                    </div>
                    <div className="col">
                        <div className="imgText">
                            <a target="_blank"  href="https://sahel.tatweertransit.com">
                                <img src="/static/img/04.png" alt="img" className="img-fluid" />
                                <h4 className="shape-round">التعريف بالراتب</h4>
                            </a>
                        </div>
                    </div>
                    <div className="col">
                        <div className="imgText">
                            <a target="_blank"  href="https://sahel.tatweertransit.com">
                                <img src="/static/img/03.png" alt="img" className="img-fluid" / >
                                <h4 className="shape-round">طلبات الشراء</h4>
                            </a>
                        </div>
                    </div>
                    <div className="col">
                        {/* <div className="imgText">
                            <a target="_blank"   href="https://tatweertransit.udemy.com">
                                <img src="/static/img/02.png" alt="img" className="img-fluid" />
                                <h4 className="shape-round">منصة كلاسيرا</h4>
                            </a>
                        </div> */}
                    </div>
                    <div className="col align-self-center d-lg-none d-sm-block d-none">
                        <div className="leftImages">
                            <img src="/static/img/01.png" alt="img" className="img-fluid" />
                            <h4 className="shape-round">استفتاء</h4>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div className="col-sm-3 col-6 mt-sm-0 mt-4 align-self-center d-lg-block d-sm-none">
            <div className="leftImages">
                <img src="/static/img/01.png" alt="img" className="img-fluid" />
                <h4 className="shape-round">استفتاء</h4>
            </div>
        </div>
    </div>
</div>
  );
}

export default ServicesComponent;


